<template>
  <el-dialog
    title="Заявка на создание баз данных"
    :visible="visible"
    width="30%"
    @update:visible="updateVisible">
    <checkbox-list no-select-all :list="databases" :checked.sync="checked" />
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="!checked.length" type="primary" @click="sendCreatingRequest">Отправить</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import CheckboxList from '@/components/CheckboxList.vue'

  export default {
    components: {
      CheckboxList
    },

    props: {
      visible: Boolean
    },

    data() {
      return {
        databases: [],
        checked: []
      }
    },

    async created() {
      this.databases = (await this.$http.getDatabasesToCreate()).data
    },

    methods: {
      async sendCreatingRequest() {
        await this.$http.createDatabases({ databasesIDs: this.checked })
        this.updateVisible(false)

        this.$notify({
          title: 'Создание баз',
          message: 'На создание баз потребуется определенное время. Для уточнения с вами свяжется наш менеджер',
          type: 'success'
        })
      },

      updateVisible(val) {
        this.$emit('update:visible', val)
      }
    }
  }
</script>